import React, { memo, useEffect, useState, useMemo, useCallback } from 'react';
import Select from 'xpi-black-ui/Base/Select';
import Wrapper, { WrapperSelect, WrapperOrderBy } from './styles';

function GenericOrderBy({ onChange, title, initialOptions, options }) {
  const [selectValue, setSelectValue] = useState(initialOptions);
  const [isOrderBy, setIsOrderBy] = useState(false);
  const [isOrderned, setIsOrderned] = useState(false);

  const onChangeData = useMemo(() => ({
    Column: selectValue.value,
    Direction: isOrderBy ? 'OrderBy' : 'OrderByDescending',
  }), [selectValue, isOrderBy]);

  const IconOrderByDescending = useCallback(() => (
    <svg width="25" height="16" viewBox="0 0 28 16" fill="none" cursor="pointer" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 9L12.59 7.59L8 12.17L8 -2.62268e-07L6 -3.49691e-07L6 12.17L1.41 7.58L-3.93402e-07 9L7 16L14 9Z" fill="#6D717A" />
      <rect x="16" y="2" width="12" height="2" fill="#6D717A" />
      <rect x="16" y="8" width="8" height="2" fill="#6D717A" />
      <rect x="16" y="14" width="4" height="2" fill="#6D717A" />
    </svg>
  ), []);

  const IconOrderByAscending = useCallback(() => (
    <svg width="25" height="16" viewBox="0 0 28 16" fill="none" cursor="pointer" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 7L12.59 8.41L8 3.83L8 16L6 16L6 3.83L1.41 8.42L-3.93402e-07 7L7 3.0598e-07L14 7Z" fill="#6D717A" />
      <rect x="16" y="2" width="12" height="2" fill="#6D717A" />
      <rect x="16" y="8" width="8" height="2" fill="#6D717A" />
      <rect x="16" y="14" width="4" height="2" fill="#6D717A" />
    </svg>
  ), []);

  const handleOnChange = useCallback(({ label, value }) => {
    setSelectValue({ label, value });
    setIsOrderned(true);
  }, []);

  const handleOnOrderBy = useCallback(() => {
    setIsOrderBy(!isOrderBy);
    setIsOrderned(true);
  }, [isOrderBy]);

  useEffect(() => {
    if (isOrderned) {
      onChange(onChangeData);
    }
  }, [onChangeData, isOrderned]);


  return (
    <Wrapper>
      {title}

      <WrapperSelect>
        <Select
          onChange={handleOnChange}
          options={options}
          value={selectValue}
          noOptionsMessage={() => 'Coluna não encontrada'}
        />
      </WrapperSelect>

      <WrapperOrderBy onClick={handleOnOrderBy}>
        {isOrderBy && <IconOrderByAscending />}
        {!isOrderBy && <IconOrderByDescending />}
      </WrapperOrderBy>
    </Wrapper>
  );
}

export default memo(GenericOrderBy);
